import { Box } from '@lingoda/ui';
import { styled } from '@lingoda/ui/theme';

const SectionWrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(0, 3),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0, 2),
    },
}));

export default SectionWrapper;
